.WaitingApproval {
	--content-space-top: 15vh;
	text-align: center;
}

.WaitingApproval__title {
	font: var(--title-medium);
	margin-bottom: 60px;
}

.WaitingApproval__info {
	margin-bottom: 60px;
}

.WaitingApproval__info p {
	font: var(--body-small);
}

.WaitingApproval__link{}